<div class="auth-flex-columns">
    <div class="auth-inner-wrapper min-height">
        <div class="form-block">
            <div class="heading no-margin-bottom">
                    <h1  class="page-title">
                        @if(dialogData?.type == AuthSuccessDialogType.Register){
                            Verify your email
                        } @else if(dialogData?.type == AuthSuccessDialogType.ForgotPassword){
                            Forgot password
                        }
                        </h1>
                <img class="description-img" src="./../../../../assets/images/auth/success.svg" alt="registration-success">
                <h2 class="subtext">Success</h2>
                <p  class="auth-page-description success">
                    @if(dialogData?.type == AuthSuccessDialogType.Register){
                        We've sent you a confirmation link to: <b>{{dialogData?.email}}</b>.<br />Check your email to proceed to the final step of the registration.
                    } @else if(dialogData?.type == AuthSuccessDialogType.ForgotPassword){
                       An email has been sent to: <b>{{dialogData?.email}}</b>.<br />Please check and follow the included instructions.
                    }
                </p>
                <div style="margin-top:30px;">
                    <button  class="c-button secondary w-100" pButton pRipple (click)="openLoginDialog()">
                        <span >Sign in</span>
                        <img class="btn-icon ml-8-px" src="./../../../../assets/images/icons/arrow-right-white.svg" alt="sign-in">
                    </button>
                    
                    <div class="extra-links">
                        <p class="line">
                            <span>Go back to <a (click)="openLoginDialog()">Home</a></span>
                        </p>
                    </div>
                </div>
                <!--
                                    <a (click)="openLoginDialog()" class="btn-imitate-primary">
                        <span >Sign in</span>
                        <img class="btn-icon ml-8-px" src="./../../../../assets/images/icons/arrow-right-white.svg" alt="sign-in">
                    </a>
                -->

             
          
                

              
       
            </div>
        </div>
    </div>

    <div class="banner-container">
        <app-current-banner [minWidth]="380" [authDialogStyles]="true"></app-current-banner>
    </div>

</div>
   